import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { useWishlistContext } from '../contexts/WishlistContext';
import { AuthContext } from '../contexts/AuthContext';

/**
 * WishlistIcon Component
 *
 * Displays wishlist icon with item count in header
 */
const WishlistIcon = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { itemCount, loading } = useWishlistContext();

  // Don't show if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <Link
      to="/wishlist"
      className="wishlist-icon-link"
      aria-label={`Wishlist (${itemCount} items)`}
    >
      <div className="wishlist-icon-container">
        <i className="far fa-heart fa-lg"></i>
        {itemCount > 0 && !loading && (
          <span className="wishlist-badge">
            {itemCount > 99 ? '99+' : itemCount}
          </span>
        )}
      </div>
    </Link>
  );
};

export default WishlistIcon;
